<template>    
        <BaseLayout :class="coordinates? 'baselayout-card-body-no-padding' : ''">
            <div v-if="!coordinates">
                <h4>Onde me conectar</h4>
                <p>Localize os pontos de WIFI proximos a você pra</p>
                <b-button variant="primary" @click="getLocation">Ativar localização</b-button>            
            </div>
            <div v-else>
                <GmapMap
                :options="{
                    zoomControl: false,
                    mapTypeControl: false,
                    scaleControl: false,
                    streetViewControl: false,
                    rotateControl: false,
                    fullscreenControl: true,
                    disableDefaultUi: false
                }"
                :center="{lat:coordinates.lat, lng:coordinates.lng}"
                :zoom="15"
                map-type-id="terrain"
                class="places-map"
                >
                <GmapMarker
                    :key="index"
                    v-for="(m, index) in markers"
                    :position="m.position"
                    :clickable="true"
                    :draggable="true"
                    @click="center=m.position"
                />
                </GmapMap>
            </div>
        </BaseLayout>
</template>
<style>
.places-map{
    width: 100%;
    min-height: 500px;
}
</style>
<script>

import BaseLayout from '@/components/BaseLayout'

export default {
    components: {        
        BaseLayout
    },
    data(){
        return {
            coordinates:false,
            markers:[]
        }
    },
    methods:{
        getLocation(){
            let instance = this;
            let options = {                
            }
            this.$getLocation(options)
            .then(coordinates => {
                instance.coordinates = coordinates;
                console.log(coordinates);
            });
        }
    }
}
</script>